export default "__VITE_ASSET__B5yJbatQ__"